export const environment = {

  // apiBaseUrl: 'https://freeridedevapi.chennaimetrorail.org', //dev new 
  //  apiBaseUrl: 'https://localhost:52710', 
  apiBaseUrl: 'https://commuters-dataapi.chennaimetrorail.org',
  tokenEndPoint: '/api/token',
  dataInterval: 10000,
  year: 2018,
  production: false,
  environment: 'Local',
  showEnvironment: true,
};
